<template>
  <Select
    :value="value"
    :title="title"
    :necessary="necessary"
    :label="label"
    :validate="validate"
    :optionList="countryList"
    :option="{ label: 'name', value: 'name' }"
    v-bind="$attrs"
    @change="onChange"
  />
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, toRefs } from 'vue'
import { useStoreHooks } from '@/store/hook'
import Select from './select.vue'

export default defineComponent({
  components: { Select },
  props: ['value', 'label', 'disabled', 'rulesContent', 'necessary', 'countryQueryType', 'validate', 'title'],
  emits: ['update:value', 'update:validate', 'change'],
  setup (props, ctx) {
    const { dispatch, state: _state } = useStoreHooks()
    onMounted(() => {
      dispatch('common/getCountryList', { countryQueryType: props.countryQueryType })
    })
    const { value } = toRefs(props)
    const countryList = computed(() => _state.common.countryList)
    return {
      value,
      countryList,
      onChange (val: any) {
        const item = _state.common.countryList.find(i => i.name === val)
        if (item) {
          const regionCode = item.regionCode || ''
          const regionId = item.regionId || item.id
          ctx.emit('change', {
            label: regionCode,
            value: val,
            regionId
          })
        }
        ctx.emit('update:value', val)
        if (!val && props.necessary) {
          ctx.emit('update:validate', true)
        } else {
          ctx.emit('update:validate', false)
        }
      }
    }
  }
})
</script>
<style lang="less" scoped>
@import './index.less';
:deep(.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder) {
  height: 40px !important;
  line-height: 40px !important;
}
:deep(.ant-select-selector) {
  height: 40px !important;
}
:deep(.ant-select-selection-search-input) {
  height: 40px !important;
  line-height: 40px !important;
}
</style>
